import React from 'react';
import { ArrowRight, Sparkles, Target, Mail, Repeat, Layers, Users, Mountain, TrendingUp, ShoppingBag } from 'lucide-react';

// ── High5 — Cross-Marketing Senaryoları ────────────────────────────────────
// Rakamlar GA4 item sales (bq_ga4_item_sales_daily), son 6 ay (Ara 2025 – Haz 2026).
const PERIOD = 'Son 6 ay (Ara 2025 – Haz 2026) · GA4 item sales';

const tl = (n) => '₺' + Number(n || 0).toLocaleString('tr-TR');

const PRIO = {
  high: { label: 'Yüksek', cls: 'bg-red-100 text-red-700' },
  mid: { label: 'Orta', cls: 'bg-amber-100 text-amber-700' },
};

const CH = {
  meta: { label: 'Meta Retargeting', cls: 'bg-blue-50 text-blue-700 border-blue-100' },
  dpa: { label: 'Meta DPA', cls: 'bg-blue-50 text-blue-700 border-blue-100' },
  lal: { label: 'Lookalike', cls: 'bg-indigo-50 text-indigo-700 border-indigo-100' },
  email: { label: 'E-posta', cls: 'bg-emerald-50 text-emerald-700 border-emerald-100' },
  onsite: { label: 'On-site Widget', cls: 'bg-purple-50 text-purple-700 border-purple-100' },
  interest: { label: 'Meta Interest', cls: 'bg-blue-50 text-blue-700 border-blue-100' },
};

const scenarios = [
  {
    icon: Sparkles, prio: 'high',
    title: 'On ayakkabı alıcısı → Fabletics (kadın activewear)',
    source: 'On Kadın Spor Ayakkabı alıcısı',
    target: 'Fabletics apparel',
    rationale: 'On premium koşu/lifestyle ayakkabı alan kadın kitle, tamamlayıcı activewear apparel için birebir hedef. Fabletics neredeyse penetrasyonsuz — en büyük çapraz-satış boşluğu. Ayrıca On erkek alıcısının kadın hane bireyine ulaşma.',
    metrics: [
      ['Kaynak kitle', tl(2135753), 'On Kadın Ayakkabı'],
      ['Hedef mevcut', tl(16494), 'Fabletics (toplam)'],
      ['Fırsat', '3–5×', '~₺50–80K / 6 ay'],
    ],
    channels: ['meta', 'email', 'onsite'],
    next: 'On kadın PDP ziyaretçisi + satın alanlara Fabletics retargeting; post-purchase "tamamla" e-postası.',
  },
  {
    icon: ShoppingBag, prio: 'high',
    title: 'Erkek ayakkabı alıcısı → On Üst Giyim + Aksesuar',
    source: 'Erkek Spor Ayakkabı havuzu (On+Asics+HOKA+Brooks)',
    target: 'On Erkek Üst Giyim & Aksesuar',
    rationale: 'En büyük kitle havuzu (~₺6.4M erkek ayakkabı). On zaten erkek apparel/aksesuar satıyor; ayakkabı→giyim attach ile sepet (AOV) büyütme. Stok hazır, marj yüksek.',
    metrics: [
      ['Kaynak kitle', tl(6400000), 'Erkek ayakkabı (tüm markalar)'],
      ['Hedef mevcut', tl(591185 + 704871), 'On Üst Giyim + Aksesuar'],
      ['Fırsat', 'AOV +%8–12', 'attach oranı'],
    ],
    channels: ['email', 'onsite', 'dpa'],
    next: 'Post-purchase "complete the look" e-postası + on-site bundle + cross-category DPA.',
  },
  {
    icon: TrendingUp, prio: 'high',
    title: 'Asics alıcısı → On (premium upsell + apparel)',
    source: 'Asics alıcısı',
    target: 'On hero (Cloud) + On apparel',
    rationale: 'Aynı performans-koşu kategorisi; Asics value/performans, On premium lifestyle-performans. Asics kitlesi ayakkabı ağırlıklı, apparel\'i zayıf — hem marka çapraz-alışverişi hem apparel boşluğu.',
    metrics: [
      ['Kaynak kitle', tl(2594070), 'Asics (toplam)'],
      ['Hedef mevcut', tl(8711129), 'On (toplam)'],
      ['Fırsat', '%5 dönüşüm', '~₺130K'],
    ],
    channels: ['meta', 'lal', 'email'],
    next: 'Asics PDP ziyaretçisine On Cloud retargeting + Asics-alıcı lookalike ile On prospecting.',
  },
  {
    icon: Repeat, prio: 'mid',
    title: 'HOKA alıcısı → On / Asics (yastıklı yol koşusu)',
    source: 'HOKA alıcısı (konfor / maksimalist)',
    target: 'On Cloud / Asics Gel yastıklı modeller',
    rationale: 'HOKA alıcısı konfor/yastık arıyor — aynı kullanım ihtiyacı, farklı marka. Cross-shop fırsatı; benzer modellerle marka çeşitlendirme.',
    metrics: [
      ['Kaynak kitle', tl(816102), 'HOKA (toplam)'],
      ['Hedef mevcut', tl(8711129 + 2594070), 'On + Asics'],
      ['Fırsat', '%6 dönüşüm', '~₺50K'],
    ],
    channels: ['meta', 'email'],
    next: 'HOKA PDP/alıcılara "benzer yastıklı modeller" retargeting + e-posta.',
  },
  {
    icon: Mountain, prio: 'mid',
    title: 'Salomon / trail alıcısı → Outdoor aksesuar + Biolite',
    source: 'Salomon (trail / outdoor) alıcısı',
    target: 'Biolite + outdoor aksesuar',
    rationale: 'Bitişik aktivite: trail koşu → kamp/outdoor. Salomon kitlesine outdoor aksesuar attach; Biolite (outdoor ürün) için niş ama yüksek ilgili kitle.',
    metrics: [
      ['Kaynak kitle', tl(169023), 'Salomon (toplam)'],
      ['Hedef mevcut', tl(49491), 'Biolite + aksesuar'],
      ['Fırsat', '2–3×', 'aksesuar attach'],
    ],
    channels: ['email', 'interest'],
    next: 'Salomon alıcılara outdoor aksesuar e-postası + Meta outdoor/trail interest prospecting.',
  },
  {
    icon: Users, prio: 'mid',
    title: 'Kadın ayakkabı kümesi → Kadın aksesuar + Fabletics + Biolite',
    source: 'Kadın Spor Ayakkabı havuzu (On+Asics+HOKA)',
    target: 'Kadın Aksesuar + Fabletics + Biolite',
    rationale: '~₺3.47M kadın ayakkabı kitlesini "kadın activewear" çapraz-satış kümesine bağla. Aksesuar + apparel ile tek segment üzerinden çoklu çapraz-satış.',
    metrics: [
      ['Kaynak kitle', tl(3460000), 'Kadın ayakkabı (tüm markalar)'],
      ['Hedef mevcut', tl(60664 + 49491 + 16494), 'Kadın aksesuar + Fabletics'],
      ['Fırsat', '%3 attach', '~₺100K'],
    ],
    channels: ['onsite', 'email', 'meta'],
    next: 'On-site "Women\'s Edit" + kadın segment e-posta + Meta kadın retargeting.',
  },
  {
    icon: Layers, prio: 'mid',
    title: 'Aksesuar/apparel-only alıcı → Hero ayakkabı (On Cloud)',
    source: 'Sadece aksesuar/üst giyim alan düşük-AOV kitle',
    target: 'On Cloud flagship ayakkabı',
    rationale: 'Ters çapraz-satış: düşük-AOV (aksesuar/apparel) alıcıyı yüksek-AOV hero ürüne taşı. Marka içi yukarı-satış; CLV artışı.',
    metrics: [
      ['Kaynak kitle', tl(704871 + 591185 + 468315), 'On apparel/aksesuar'],
      ['Hedef mevcut', tl(4569477 + 2135753), 'On ayakkabı'],
      ['Fırsat', '%4 dönüşüm', 'AOV sıçraması'],
    ],
    channels: ['email', 'meta'],
    next: 'Aksesuar-only segmentine On Cloud hero e-postası + retargeting.',
  },
];

export default function High5CrossMarketing() {
  return (
    <div className="min-h-screen bg-[#f6f8ff]/70 p-6">
      <div className="max-w-6xl mx-auto space-y-6">
        {/* Header */}
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 flex items-start gap-4">
          <div className="p-3 bg-indigo-50 border border-indigo-100 rounded-xl">
            <Target className="w-6 h-6 text-indigo-600" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-gray-900">High5 — Cross-Marketing Senaryoları</h1>
            <p className="text-sm text-gray-500 mt-1">Markalar arası çapraz-satış / çapraz-pazarlama fırsatları — gerçek satış verisine dayalı.</p>
            <p className="text-xs text-gray-400 mt-1">{PERIOD}</p>
          </div>
        </div>

        {/* Scenario cards */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
          {scenarios.map((s, i) => {
            const Icon = s.icon;
            const prio = PRIO[s.prio];
            return (
              <div key={i} className="bg-white rounded-2xl shadow-sm border border-gray-100 p-5 flex flex-col">
                <div className="flex items-start justify-between gap-3 mb-3">
                  <div className="flex items-center gap-2">
                    <div className="p-2 bg-gray-50 rounded-lg"><Icon className="w-4 h-4 text-indigo-600" /></div>
                    <span className="text-[11px] font-bold text-gray-400">#{i + 1}</span>
                  </div>
                  <span className={`text-[10px] font-bold px-2 py-0.5 rounded-full ${prio.cls}`}>{prio.label} öncelik</span>
                </div>

                <h2 className="text-base font-bold text-gray-900 leading-snug">{s.title}</h2>

                {/* source → target */}
                <div className="flex items-center gap-2 mt-3 flex-wrap">
                  <span className="text-xs bg-blue-50 text-blue-700 rounded-lg px-2 py-1 font-medium">{s.source}</span>
                  <ArrowRight className="w-4 h-4 text-gray-400 shrink-0" />
                  <span className="text-xs bg-orange-50 text-orange-700 rounded-lg px-2 py-1 font-medium">{s.target}</span>
                </div>

                <p className="text-xs text-gray-600 leading-relaxed mt-3">{s.rationale}</p>

                {/* metrics */}
                <div className="grid grid-cols-3 gap-2 mt-4">
                  {s.metrics.map(([label, value, sub]) => (
                    <div key={label} className="rounded-lg bg-gray-50 border border-gray-100 p-2.5">
                      <div className="text-[10px] text-gray-400 uppercase">{label}</div>
                      <div className="text-sm font-bold text-gray-900 tabular-nums">{value}</div>
                      <div className="text-[10px] text-gray-400 truncate" title={sub}>{sub}</div>
                    </div>
                  ))}
                </div>

                {/* channels */}
                <div className="flex flex-wrap gap-1.5 mt-4">
                  {s.channels.map((c) => (
                    <span key={c} className={`text-[10px] font-medium px-2 py-0.5 rounded-full border ${CH[c].cls}`}>{CH[c].label}</span>
                  ))}
                </div>

                {/* next step */}
                <div className="mt-4 pt-3 border-t border-gray-100 flex items-start gap-1.5">
                  <Mail className="w-3.5 h-3.5 text-gray-400 mt-0.5 shrink-0" />
                  <p className="text-[11px] text-gray-500 leading-snug">{s.next}</p>
                </div>
              </div>
            );
          })}
        </div>

        <p className="text-xs text-gray-400 pb-6">
          Not: "Kaynak kitle" ve "Hedef mevcut" rakamları son 6 aylık GA4 item-sales gelirleridir (kitle proxy'si).
          "Fırsat" kolonu kaba tahmindir — gerçek çapraz-satış ölçümü için kullanıcı/sipariş düzeyinde co-purchase analizi gerekir.
          On = hero marka (~₺8.7M), Fabletics neredeyse penetrasyonsuz (₺16K) → en yüksek getirili çapraz-satış hedefi.
        </p>
      </div>
    </div>
  );
}
